module.exports = __webpack_public_path__ + "media/whats_your_status_series/learn-more_cta-3d30fa68.png";